export function dedupeByArtwork(results) {
  const seen = new Set();
  const unique = [];
  for (const song of results) {
    const key = song.artworkUrl100 || song.trackId;
    if (!seen.has(key)) {
      seen.add(key);
      unique.push(song);
    }
  }
  return unique;
}

export function filterRelevant(results, searchTerm) {
  const stopWords = ["songs", "song", "music", "the", "and", "of", "in", "a"];
  const words = searchTerm.toLowerCase().split(/\s+/).filter(w => w.length > 2 && !stopWords.includes(w));
  if (words.length === 0) return results;
  return results.filter(song => {
    const text = `${song.trackName} ${song.artistName} ${song.collectionName || ""}`.toLowerCase();
    return words.some(w => text.includes(w));
  });
}